// GENERATED FILE - DO NOT MODIFY
import { ContactLookupModel } from "api/models/company/contact/contact-lookup-model";
import { ContactModel } from "api/models/company/contact/contact-model";
import { PagingInfo } from "api/paging-info";
import BaseProxy from "api/proxies/base-proxy";
import ModelDateTransformer from "api/util/model-date-transformer";
import { autoinject } from "aurelia-framework";
import { ApiHelper } from "helpers/api-helper";
import { HttpClientFactory } from "http-client/http-client-factory";
import { HttpClientRequestConfig } from "http-client/http-client-request-config";

@autoinject()
export class ContactProxy extends BaseProxy {
    constructor(modelDateTransformer: ModelDateTransformer, httpClientFactory: HttpClientFactory, apiHelper: ApiHelper) {
        super(modelDateTransformer, httpClientFactory, apiHelper);
    }

    public async GetContact(contactId: number, requestConfig?: HttpClientRequestConfig): Promise<ContactModel | null> {
        const uri = this.buildUri(
            "/contacts/{contactId}",
            { contactId: (contactId === null || contactId === undefined) ? undefined : contactId.toString() },
            null
        );

        const data: ContactModel | null = await this.get<ContactModel | null>(uri, requestConfig);
        this.transformModels(data, "Company.Contact.ContactModel");
        return data;
    }

    public async GetContactLookup(contactId: number, requestConfig?: HttpClientRequestConfig): Promise<ContactLookupModel | null> {
        const uri = this.buildUri(
            "/contacts/{contactId}/lookup",
            { contactId: (contactId === null || contactId === undefined) ? undefined : contactId.toString() },
            null
        );

        const data: ContactLookupModel | null = await this.get<ContactLookupModel | null>(uri, requestConfig);
        this.transformModels(data, "Company.Contact.ContactLookupModel");
        return data;
    }

    public async GetContacts(clientId: string | null | undefined, filter?: string, pagingInfo?: PagingInfo, requestConfig?: HttpClientRequestConfig): Promise<ContactModel[] | null> {
        const uri = this.buildUri(
            "/contacts",
            null,
            { clientId: (clientId === null || clientId === undefined) ? undefined : clientId, filter: filter ? filter : undefined, page: (pagingInfo && pagingInfo.page ? pagingInfo.page.toString() : undefined), pagesize: (pagingInfo && pagingInfo.pageSize ? pagingInfo.pageSize.toString() : undefined) }
        );

        const data: ContactModel[] | null = await this.get<ContactModel[] | null>(uri, requestConfig);
        this.transformModels(data, "Company.Contact.ContactModel");
        return data;
    }

    public async GetContactsLookup(clientId: string | null | undefined, getEmployeeContacts: boolean | undefined, filter?: string, pagingInfo?: PagingInfo, requestConfig?: HttpClientRequestConfig): Promise<ContactLookupModel[] | null> {
        const uri = this.buildUri(
            "/contacts/lookup",
            null,
            { clientId: (clientId === null || clientId === undefined) ? undefined : clientId, getEmployeeContacts: (getEmployeeContacts === null || getEmployeeContacts === undefined) ? undefined : getEmployeeContacts.toString(), filter: filter ? filter : undefined, page: (pagingInfo && pagingInfo.page ? pagingInfo.page.toString() : undefined), pagesize: (pagingInfo && pagingInfo.pageSize ? pagingInfo.pageSize.toString() : undefined) }
        );

        const data: ContactLookupModel[] | null = await this.get<ContactLookupModel[] | null>(uri, requestConfig);
        this.transformModels(data, "Company.Contact.ContactLookupModel");
        return data;
    }
}
